import BugsnagPerformance from '@bugsnag/browser-performance';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';

Bugsnag.start({
  apiKey: import.meta.env.VITE_BUGSNAG_API_KEY,
  plugins: [new BugsnagPluginVue()],
  autoTrackSessions: true,
  autoTrackCrashes: true,
  releaseStage: import.meta.env.VITE_ENVIRONMENT,
  enabledReleaseStages: ['production', 'development', 'staging'],
  onError: (event) => {
    return true; // returns true to send the error to bugsnag
  },
});

BugsnagPerformance.start({
  apiKey: import.meta.env.VITE_BUGSNAG_API_KEY,
  releaseStage: import.meta.env.VITE_ENVIRONMENT,
  enabledReleaseStages: ['production', 'development', 'staging'],
});

export default Bugsnag;
